import React, { useState } from 'react';
import { StyleSheet, Modal, View, Text, TextInput, TouchableOpacity, Alert, ScrollView, Linking, SafeAreaView } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

export default function App({ navigation }) {
  const [location, setLocation] = useState('');
  const [listingDescription, setListingDescription] = useState('');
  const [redeemMessage, setRedeemMessage] = useState('');
  const [adHeader, setAdHeader] = useState('');
  const [brandURL, setBrandURL] = useState('');
  const [credits, setCredits] = useState('');
  const [preferredAvailability, setPreferredAvailability] = useState('');
  const [contentBrief1, setContentBrief1] = useState('');
  const [contentBrief2, setContentBrief2] = useState('');
  const [contentBrief3, setContentBrief3] = useState('');
  const [nonCreditOffer, setNonCreditOffer] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);  // New state for the checkbox

  const [status, setStatus] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [minFollowersRequired, setMinFollowersRequired] = useState('No min.');
  const [turnAroundDays, setTurnAroundDays] = useState('');


  const [advanceDays, setAdvanceDays] = useState(''); // empty = no restriction


const [isTimeModalVisible, setIsTimeModalVisible] = useState(false);
const [selectedDay, setSelectedDay] = useState('');
const [selectedTimeType, setSelectedTimeType] = useState(''); // 'open' or 'close'
const [selectedTime, setSelectedTime] = useState('');

const [briefPoints, setBriefPoints] = useState(["", "", ""]);


const [isSuccessModalVisible, setSuccessModalVisible] = useState(false);


const [showErrorModal, setShowErrorModal] = useState(false);
const [errorMessage, setErrorMessage] = useState('');

const [venueType, setVenueType] = useState('Restaurant');
const [dropdownVisibleVenueType, setDropdownVisibleVenueType] = useState(false);

const [isSubmitting, setIsSubmitting] = useState(false);


const [managedAccounts, setManagedAccounts] = useState([]);
const [selectedAccount, setSelectedAccount] = useState('');
const [showManagedModal, setShowManagedModal] = useState(false);




const handleBriefPointChange = (index, text) => {
  const updatedBriefPoints = [...briefPoints];
  updatedBriefPoints[index] = text;
  setBriefPoints(updatedBriefPoints);
};

const timeOptions = [
  '-', // Represents no time (blank value)
  '6:00 AM', '6:30 AM', 
  '7:00 AM', '7:30 AM', 
  '8:00 AM', '8:30 AM', 
  '9:00 AM', '9:30 AM', 
  '10:00 AM', '10:30 AM', 
  '11:00 AM', '11:30 AM', 
  '12:00 PM', '12:30 PM', 
  '1:00 PM', '1:30 PM', 
  '2:00 PM', '2:30 PM', 
  '3:00 PM', '3:30 PM', 
  '4:00 PM', '4:30 PM', 
  '5:00 PM', '5:30 PM', 
  '6:00 PM', '6:30 PM', 
  '7:00 PM', '7:30 PM', 
  '8:00 PM', '8:30 PM', 
  '9:00 PM', '9:30 PM', 
  '10:00 PM', '10:30 PM', 
  '11:00 PM', '11:30 PM', 
  '12:00 AM', '12:30 AM', 
  '1:00 AM', '1:30 AM', 
];


const showMissingFieldModal = (message) => {
  setErrorMessage(message);
  setShowErrorModal(true);
};



const handleTimeSelection = (day, type, time) => {
  const value = time === '-' ? '' : time; // Blank if '-' selected
  setAvailability((prev) =>
    prev.map((item) =>
      item.day === day ? { ...item, [type]: value } : item
    )
  );
  setIsTimeModalVisible(false);
};



const openTimeModal = (day, type) => {
  setSelectedDay(day);
  setSelectedTimeType(type);
  setIsTimeModalVisible(true);
};




const [additionalBookingDetails, setAdditionalBookingDetails] = useState('N'); // Default is 'Off'


  const handleBackPress = () => {
    navigation.goBack();
  };

  const followerOptions = [
    { label: 'No min.', value: 0 },
    { label: '2k', value: 2000 },
    { label: '5k', value: 5000 },
    { label: '10k', value: 10000 },
    { label: '15k', value: 15000 },
    { label: '20k', value: 20000 },
    { label: '25k', value: 25000 },
    { label: '30k', value: 30000 },
    { label: '35k', value: 35000 },
    { label: '40k', value: 40000 },
    { label: '45k', value: 45000 },
    { label: '50k', value: 50000 },
    { label: '60k', value: 60000 },
    { label: '70k', value: 70000 },
    { label: '80k', value: 80000 },
    { label: '90k', value: 90000 },
    { label: '100k', value: 100000 },
    { label: '150k', value: 150000 },
    { label: '200k', value: 200000 },
    { label: '250k', value: 250000 },
    { label: '300k', value: 300000 },
    { label: '350k', value: 350000 },
    { label: '400k', value: 400000 },
    { label: '450k', value: 450000 },
    { label: '500k', value: 500000 },
  ];

  const [availability, setAvailability] = useState([
    { day: 'Monday', open: '', close: '' },
    { day: 'Tuesday', open: '', close: '' },
    { day: 'Wednesday', open: '', close: '' },
    { day: 'Thursday', open: '', close: '' },
    { day: 'Friday', open: '', close: '' },
    { day: 'Saturday', open: '', close: '' },
    { day: 'Sunday', open: '', close: '' },
  ]);
  
  const handleTimeChange = (day, type, value) => {
    setAvailability((prev) =>
      prev.map((item) =>
        item.day === day ? { ...item, [type]: value } : item
      )
    );
  };
  


  const toggleDropdown = () => setDropdownVisible(!isDropdownVisible);

  const selectOption = (option) => {
    setMinFollowersRequired(option.label);
    setDropdownVisible(false);
  };

  const checkStatus = async () => {
    try {
      const response = await fetch('https://collabbayadmin.com/APIControllers/CheckBrandVerificationStatus.php', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();
  
      // Check if result.Status is null or not equal to 'Business'
      if (result.Status === null || (result.Status && result.Status !== 'Business')) {
        setShowWarning(true);
      }
    } catch (error) {
      console.error('Error fetching status', error);
    }
  };
  

React.useEffect(() => {
  const fetchManagedAccounts = async () => {
    try {
      const res = await fetch('https://collabbayadmin.com/APIControllers/FetchManagedAccounts.php');
      const result = await res.json();
      if (result.accounts && result.accounts.length > 0) {
        setManagedAccounts(result.accounts);
        setShowManagedModal(true);
      }
    } catch (error) {
      console.error('Error fetching managed accounts', error);
    }
  };

  fetchManagedAccounts();
  checkStatus(); // your existing status check
}, []);

  
  const handleSubmit = async () => {
    if (isSubmitting) return; // prevent double click
    setIsSubmitting(true);
  
    if (!termsAccepted) {
      setIsSubmitting(false);
      showMissingFieldModal('You must agree to the terms of use before posting your offer.');
      return;
    }
  
    if (!location) {
      setIsSubmitting(false);
      showMissingFieldModal('Please enter the location.');
      return;
    }
  
    if (!listingDescription) {
      setIsSubmitting(false);
      showMissingFieldModal('Please enter the listing description.');
      return;
    }
  
    if (!credits) {
      setIsSubmitting(false);
      showMissingFieldModal('Please enter the value of your offer.');
      return;
    }
  
    if (!contentBrief1 && !contentBrief2 && !contentBrief3) {
      setIsSubmitting(false);
      showMissingFieldModal('Please enter at least one content brief.');
      return;
    }
  
    if (credits < 10 || credits > 10000) {
      setIsSubmitting(false);
      showMissingFieldModal('The offer of your value must be between £10 and £1,000.');
      return;
    }
  
    if (!nonCreditOffer) {
      setIsSubmitting(false);
      showMissingFieldModal('Please enter what you are offering (e.g. “2 x Cocktails and 1 Main”).');
      return;
    }
  
    if (!turnAroundDays || turnAroundDays < 2 || turnAroundDays > 7) {
      setIsSubmitting(false);
      showMissingFieldModal('Please set a content turnaround period.');
      return;
    }

    // AdvanceDays (optional): allow '', or 0–60 (adjust to taste)
if (advanceDays !== '') {
  const advNum = parseInt(String(advanceDays).replace(/[^0-9]/g, ''), 10);
  if (Number.isNaN(advNum) || advNum < 0 || advNum > 60) {
    setIsSubmitting(false);
    showMissingFieldModal('Advance days must be a whole number between 0 and 60 (or leave blank).');
    return;
  }
}

  
    const formattedAvailability = availability
      .filter((item) => item.open && item.close)
      .map((item) => `${item.day}: ${item.open} - ${item.close}`)
      .join(', ');
  
    if (!formattedAvailability) {
      setIsSubmitting(false);
      Alert.alert('Invalid Availability', 'Please select at least one day with open and close times.');
      return;
    }
  
    const contentBrief1Safe = contentBrief1.replace(/,/g, '');
    const contentBrief2Safe = contentBrief2.replace(/,/g, '');
    const contentBrief3Safe = contentBrief3.replace(/,/g, '');
    const contentBrief = [contentBrief1Safe, contentBrief2Safe, contentBrief3Safe]
      .filter((item) => item.trim() !== '')
      .join(',');
  
    const formattedBrandURL = formatBrandURL(brandURL);
  
    try {
      const response = await fetch('https://collabbayadmin.com/APIControllers/InsertCreatedBrandListing.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          Location: location,
          ListingDescription: listingDescription,
          Redeem_Message: redeemMessage,
          AdHeader: adHeader,
          BrandURL: formattedBrandURL,
          Credits: credits,
          PreferredAvailability: formattedAvailability,
          ContentBrief: contentBrief,
          NonCreditOffer: nonCreditOffer,
          MinFollowersRequired: minFollowersRequired,
          TurnAroundDays: turnAroundDays,
          AdditionalBookingDetails: additionalBookingDetails,
          OfferCategory: venueType,
          OnBehalfOf: selectedAccount,
          AdvanceDays: advanceDays === '' ? null : parseInt(advanceDays, 10),
        }),
      });
  
      const result = await response.json();
  
      if (response.ok && result.message === 'Data inserted successfully') {
        setSuccessModalVisible(true);
      } else {
        alert(result.error || 'An error occurred during submission.');
      }
    } catch (error) {
      alert('Error', 'An error occurred while submitting the form.');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  
  
  const formatBrandURL = (url) => {
    if (!url) return '';
  
    // Remove protocol (http:// or https://) if present
    url = url.replace(/^https?:\/\//, '');
  
    // Remove any trailing slash
    url = url.replace(/\/+$/, '');
  
    return url;
  };
  
  

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
    
    <SafeAreaView style={{ width: '100%', maxWidth: 600, alignSelf: 'center', backgroundColor: '#fff', flex: 1 }}>



      <ScrollView contentContainerStyle={styles.container}>
        <TouchableOpacity style={styles.backButton} onPress={handleBackPress}>
          <Ionicons name="arrow-back" size={24} color="black" />
        </TouchableOpacity>

        <Text style={styles.header}>
        <Text
  style={{
    color: 'black',
    padding: 17,
    marginTop: 5,
    marginBottom: 12,
    textAlign: 'center', // Optional for centering
}}>Post your offer to influencers<Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text>
</Text>

</Text>

<Text style={[styles.subHeader, { marginTop: 17, fontWeight: 'bold'}]}>
  Set up your collab offer, terms, and venue details.
</Text>

        {showWarning && (
  <View style={styles.warningCard}>
    <Ionicons name="warning-outline" size={24} color="black" />
    <Text style={styles.warningText}>
      Hey! Your account is under review. You will not be able to post offers until your account is verified. Keep an eye on your inbox.
    </Text>
  </View>
)}


<Modal
  visible={isSuccessModalVisible}
  transparent={true}
  animationType="fade"
  onRequestClose={() => setSuccessModalVisible(false)}
>
  <View style={styles.modalOverlay}>
    <View style={styles.successModalContent}>
      <Ionicons name="checkmark-circle-outline" size={60} color="green" style={styles.successIcon} />
      <Text style={styles.successModalMessage}>
        Listing posted. Add a banner image, edit and manage the offer from your dashboard via 'My Offers'.
      </Text>
      <Ionicons name="create-outline" size={40} color="black" style={styles.editIcon}/>
      <TouchableOpacity
  style={styles.successModalButton}
  onPress={() => {
    setSuccessModalVisible(false);
    navigation.navigate('BrandListingsDashboard');
  }}
>
  <Text style={styles.successModalButtonText}>Close</Text>
</TouchableOpacity>

    </View>
  </View>
</Modal>


{managedAccounts.length > 0 && (
  <View style={{ marginTop: 20 }}>
    <TouchableOpacity
      style={[styles.dropdownButton, { backgroundColor: '#f5f5f5' }]}
      onPress={() => setDropdownVisible(!isDropdownVisible)}
    >
      <Text style={styles.dropdownButtonText}>
        {selectedAccount ? `Posting as: ${selectedAccount}` : '+ Post on behalf of an account'}
      </Text>
      <Ionicons name={isDropdownVisible ? 'chevron-up-outline' : 'chevron-down-outline'} size={20} color="black" />
    </TouchableOpacity>

    {isDropdownVisible && (
      <View style={styles.dropdownList}>
        {managedAccounts.map((account, index) => (
          <TouchableOpacity
            key={index}
            style={styles.dropdownItem}
            onPress={() => {
              setSelectedAccount(account);
              setDropdownVisible(false);
            }}
          >
            <Text style={styles.dropdownItemText}>{account}</Text>
          </TouchableOpacity>
        ))}
      </View>
    )}
  </View>
)}




{/* Preferred Availability Section */}
<Text style={styles.sectionHeader}>1. Set Your Availability<Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text></Text>
<Text style={styles.sectionDescription}>
  Select your booking availability, this can be your standard opening hours, or a specific timeframe you want influencer bookings for. At least one day must be filled, leave blank any days the venue is closed. 
</Text>
        <View style={styles.inputContainer}>
          <Ionicons name="calendar-outline" size={24} color="black" style={styles.icon} />
         


          <View style={styles.availabilityTable}>
  {availability.map((item, index) => (
    <View key={index} style={styles.row}>
      <Text style={styles.dayLabel}>{item.day}</Text>
      <TouchableOpacity
        style={styles.timeInput}
        onPress={() => openTimeModal(item.day, 'open')}
      >
        <Text>{item.open || '-'}</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={styles.timeInput}
        onPress={() => openTimeModal(item.day, 'close')}
      >
        <Text>{item.close || '-'}</Text>
      </TouchableOpacity>
    </View>
  ))}
</View>



<Modal
  visible={isTimeModalVisible}
  transparent={true}
  animationType="slide"
  onRequestClose={() => setIsTimeModalVisible(false)}
>
  <View style={styles.modalContainer}>
    <View style={styles.modalContent}>
      <Text style={styles.modalTitle}>Select Time</Text>
      <ScrollView 
        style={styles.timeList} 
        contentContainerStyle={{ paddingBottom: 20 }}
      >
        {timeOptions.map((time, index) => (
          <TouchableOpacity
            key={index}
            style={styles.timeItem}
            onPress={() => handleTimeSelection(selectedDay, selectedTimeType, time)}
          >
            <Text style={styles.timeText}>{time}</Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
      <TouchableOpacity
        style={styles.modalCloseButton}
        onPress={() => setIsTimeModalVisible(false)}
      >
        <Text style={styles.modalCloseButtonText}>Cancel</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>




        </View>
        <View style={styles.inputContainer}>
          <Ionicons name="location-outline" size={24} color="black" style={styles.icon} />
          <TextInput
            style={styles.input}
            placeholderTextColor="gray"
            placeholder="i.e. City of London,  54 Example Road, W1R 3QL"
            value={location}
            onChangeText={setLocation}
            maxLength={300}
          />
        </View>

        <View style={styles.inputContainer}>
    <Ionicons name="text-outline" size={24} color="black" style={styles.icon} />
    <View style={{ flex: 1 }}>
        <TextInput
            style={[styles.input, { height: 300 }]}
            placeholder="Describe your brand or location, highlight unique features, and entice creators to visit."
            value={listingDescription}
            placeholderTextColor="gray"
            onChangeText={(text) => setListingDescription(text)}
            multiline={true}
            maxLength={525} // Set the character limit
        />
        <Text style={styles.charCounter}>
            {listingDescription.length} / 525
        </Text>
    </View>
</View>


        {/* Content Details Section */}
        <Text style={styles.sectionHeader}>2. Outline Content Details<Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text></Text>
        <Text style={styles.sectionDescription}>Outline the content brief and guidelines for influencers so they know what to do when they visit.</Text>
   
        <View style={styles.inputContainer}>
  <Ionicons name="bulb-outline" size={24} color="black" style={styles.icon} />
  <View style={{ flex: 1 }}>
    <TextInput
      style={styles.input}
      placeholderTextColor="gray"
      placeholder="Brief Point 1 (i.e. 'Mention our new menu')"
      value={contentBrief1}
      maxLength={50}
      onChangeText={(text) => setContentBrief1(text.replace(/,/g, ''))}
    />
    <Text style={styles.charCounter}>{contentBrief1.length} / 50</Text>
  </View>
</View>
<View style={styles.inputContainer}>
  <Ionicons name="bulb-outline" size={24} color="black" style={styles.icon} />
  <View style={{ flex: 1 }}>
    <TextInput
      style={styles.input}
      placeholderTextColor="gray"
      placeholder="Brief Point 2 (i.e. 'Include cocktail in content')"
      value={contentBrief2}
      maxLength={50}
      onChangeText={(text) => setContentBrief2(text.replace(/,/g, ''))}
    />
    <Text style={styles.charCounter}>{contentBrief2.length} / 50</Text>
  </View>
</View>
<View style={styles.inputContainer}>
  <Ionicons name="bulb-outline" size={24} color="black" style={styles.icon} />
  <View style={{ flex: 1 }}>
    <TextInput
      style={styles.input}
      placeholderTextColor="gray"
      placeholder="Brief Point 3 (i.e. 'Include view from our entrance')"
      value={contentBrief3}
      maxLength={50}
      onChangeText={(text) => setContentBrief3(text.replace(/,/g, ''))}
    />
    <Text style={styles.charCounter}>{contentBrief3.length} / 50</Text>
  </View>
</View>



        <View style={styles.locationContainer}>
          <Ionicons name="logo-instagram" size={20} color="black" />
          <Text style={styles.sectionTitleAddress}>Post Type : Reel</Text>
        </View>




        <Text style={styles.sectionHeader}>3. Set Content Turnaround Days (2-7)<Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text></Text>
        <View style={styles.inputContainer}>
  <Ionicons name="time-outline" size={24} color="black" style={styles.icon} />
  <TextInput
    style={styles.input}
    placeholder="Days given to the influencer to post after their visit... 2-7"
    value={turnAroundDays}
    placeholderTextColor="gray"
    onChangeText={(text) => {
      const numericValue = parseInt(text.replace(/[^0-9]/g, ''), 10); // Convert to number, remove invalid chars
      if (numericValue >= 2 && numericValue <= 7) {
        setTurnAroundDays(String(numericValue)); // Only allow numbers in range
      } else if (!text) {
        setTurnAroundDays(''); // Allow empty input
      }
    }}
    keyboardType="numeric" // Ensure numeric keyboard on mobile
  />
</View>

<Text style={styles.sectionHeader}>
  3a. Minimum Days in Advance (optional)
  <Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text>
</Text>
<Text style={styles.sectionDescription}>
  Set your notice period. If set, creators can only propose bookings at least this many days ahead.
  Leave blank to allow any-time bookings.
</Text>
<View style={styles.inputContainer}>
  <Ionicons name="calendar-outline" size={24} color="black" style={styles.icon} />
  <TextInput
    style={styles.input}
    placeholder="i.e. 3= creators must book at least 3 days in advance  "
    value={advanceDays}
    placeholderTextColor="gray"
    onChangeText={(text) => setAdvanceDays(text.replace(/[^0-9]/g, '').slice(0, 2))}
    keyboardType="numeric"
  />
</View>


        <View style={styles.container}>
<Text style={styles.sectionDescription}>Minimum-follower requirement (No min. recommended).</Text>

      {/* Dropdown Button */}
      <TouchableOpacity style={styles.dropdownButton} onPress={toggleDropdown}>
        <Text style={styles.dropdownButtonText}>{minFollowersRequired}</Text>
        <Ionicons name={isDropdownVisible ? 'chevron-up-outline' : 'chevron-down-outline'} size={20} color="black" />
      </TouchableOpacity>

      {/* Dropdown List */}
      {isDropdownVisible && (
        <ScrollView style={styles.dropdownList} nestedScrollEnabled={true}>
          {followerOptions.map((option) => (
            <TouchableOpacity
              key={option.value}
              style={styles.dropdownItem}
              onPress={() => selectOption(option)}
            >
              <Text style={styles.dropdownItemText}>{option.label}</Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      )}
    </View>

        {/* Collab Offer Section */}
        <Text style={styles.sectionHeader}>4. Create Your Comped Offer<Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text></Text>
        <Text style={styles.sectionDescription}>Specify what you're offering to the influencers as part of this collab. The 'value' is just the monetary value of your offer, i.e. if you comp 2 mains at £25 each, your offer is 2 mains- and the value is £50. </Text>
        <View style={styles.inputContainer}>
          <Ionicons name="people-outline" size={24} color="black" style={styles.icon} />
  <TextInput
  style={styles.input}
  placeholderTextColor="gray"
  multiline={true}
  placeholder="Offer i.e. '2 x Cocktail Rounds and 1 Main'"
  value={nonCreditOffer}
  onChangeText={(text) => setNonCreditOffer(text)} // Ensure no restrictions here
  maxLength={300}
/>
        </View>
        <View style={styles.inputContainer}>
          <Ionicons name="pricetag-outline" size={24} color="black" style={styles.icon} />
          <TextInput
            style={styles.input}
            placeholder="The value of your offer (i.e. £40)"
            value={credits}
            placeholderTextColor="gray"
            onChangeText={(text) => setCredits(text.replace(/[^0-9]/g, '').slice(0, 5))}
            keyboardType="numeric"
scrollEnabled
          />
        </View>

        {/* Link Details Section */}
        <Text style={styles.sectionHeader}>5. Add a CTA & Link Details<Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text></Text>
        <Text style={styles.sectionDescription}>Each of your collabs comes with a link. This URL contains your brand info, your website, and any message you'd like to present to customers, essentially an advert promoters can distribute for you. Here's an example. 
        
        <Text style={styles.termsText}><Text style={styles.linkText} onPress={() => Linking.openURL('https://collabbay.com/collab/COLL3227BQRW')}>
               Example Collab Link
            </Text>. 
          </Text>
        
        
         When influencers share this, their audience see your website, message and offer. Want bookings? Put your number in the header, or maybe you want to promote your instagram? Put your instagram page in the link section.</Text>
        <View style={styles.inputContainer}>
          <Ionicons name="newspaper-outline" size={24} color="black" style={styles.icon} />
          <TextInput
  style={[styles.input, { height: 100 }]}
  placeholder="Ad Header (i.e. 'Come and visit us to experience our new menu! Click below for more')"
  value={adHeader}
  multiline={true}
  placeholderTextColor="gray"
  onChangeText={(text) => setAdHeader(text)}
  maxLength={200}
/>
<Text style={{ alignSelf: 'flex-end', marginRight: 10, color: 'gray', fontSize: 12 }}>
  {adHeader.length}/200
</Text>

        </View>
        <View style={styles.inputContainer}>
          <Ionicons name="link-outline" size={24} color="black" style={styles.icon} />
          <TextInput
            style={styles.input}
            placeholderTextColor="gray"
            placeholder="yourwebsite.com"
            value={brandURL}
            onChangeText={setBrandURL}
            maxLength={300}
          />
        </View>

        <Text style={styles.sectionHeader}>6.Additional Booking Details<Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text></Text>
<View style={styles.toggleContainer}>
  <Text style={styles.toggleLabel}>Require full name and phone number for bookings. Not advised unless required for your other booking systems.</Text>
  <TouchableOpacity
    style={[
      styles.toggleButton,
      additionalBookingDetails === 'Y' ? styles.toggleOn : styles.toggleOff,
    ]}
    onPress={() =>
      setAdditionalBookingDetails(additionalBookingDetails === 'Y' ? 'N' : 'Y')
    }
  >
    <Text style={styles.toggleText}>
      {additionalBookingDetails === 'Y' ? 'On' : 'Off'}
    </Text>
  </TouchableOpacity>
</View>


<Text style={styles.sectionHeader}>
  7. Select Your Venue Type<Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>.</Text>
</Text>

<View style={styles.inputContainer}>
  <TouchableOpacity
    style={styles.dropdownButton}
    onPress={() => setDropdownVisibleVenueType(!dropdownVisibleVenueType)}
  >
    <Text style={styles.dropdownButtonText}>{venueType}</Text>
    <Ionicons name={dropdownVisibleVenueType ? 'chevron-up-outline' : 'chevron-down-outline'} size={20} color="black" />
  </TouchableOpacity>
</View>

{dropdownVisibleVenueType && (
  <ScrollView style={styles.dropdownList} nestedScrollEnabled={true}>
    {['Restaurant', 'Bar', 'Activity', 'Takeout Spot', 'Wellbeing and Fitness', 'Gym'].map((option) => (
      <TouchableOpacity
        key={option}
        style={styles.dropdownItem}
        onPress={() => {
          setVenueType(option);
          setDropdownVisibleVenueType(false);
        }}
      >
        <Text style={styles.dropdownItemText}>{option}</Text>
      </TouchableOpacity>
    ))}
  </ScrollView>
)}



        {/* Terms of Use Checkbox */}
        <View style={styles.termsContainer}>
          <TouchableOpacity onPress={() => setTermsAccepted(!termsAccepted)} style={styles.checkbox}>
            <Ionicons
              name={termsAccepted ? 'checkbox-outline' : 'square-outline'}
              size={24}
              color="black"
            />
          </TouchableOpacity>
          <Text style={styles.termsText}>
            By uploading this offer I agree with{' '}
            <Text style={styles.linkText} onPress={() => Linking.openURL('https://collabbay.com/PrivacyPolicy.html')}>
              Collabbay terms of use
            </Text>.
          </Text>
        </View>


        <Modal
  visible={showErrorModal}
  transparent={true}
  animationType="fade"
  onRequestClose={() => setShowErrorModal(false)}
>
  <View style={styles.modalOverlay}>
    <View style={styles.successModalContent}>
      <Ionicons name="alert-circle-outline" size={60} color="red" style={styles.successIcon} />
      <Text style={styles.successModalMessage}>
        {errorMessage}
      </Text>
      <TouchableOpacity
        style={styles.successModalButton}
        onPress={() => setShowErrorModal(false)}
      >
        <Text style={styles.successModalButtonText}>OK</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>

<TouchableOpacity
  style={[styles.button, isSubmitting && { opacity: 0.6 }]}
  onPress={handleSubmit}
  disabled={isSubmitting}
>
  <Text style={styles.buttonText}>
    {isSubmitting ? 'Uploading...' : 'Post Offer'}
  </Text>
</TouchableOpacity>


        <Text style={[styles.sectionPostDescription, { marginTop: 7 }]}>
  You'll receive email notifications on booking proposals, keep an eye out.
</Text>

      </ScrollView>
    </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: 'white',
    padding: 20,
    paddingBottom: 40,
  },
  header: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 10,
    marginTop: 27.5,
    color: 'black',
  },
  subHeader: {
    fontSize: 16,
    textAlign: 'center',
    color: 'grey',
    marginBottom: 20,
  },
  sectionHeader: {
    fontSize: 23,
    fontWeight: 'bold',
    marginBottom: 10,
    color: 'black',
    marginTop: 20,
  },
  sectionDescription: {
    fontSize: 14,
    color: 'grey',
    marginBottom: 10,
  },
  sectionPostDescription: {
    fontSize: 12,
    color: 'black',
    marginBottom: 10,
    textAlign: 'center',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 15,
  },
  icon: {
    marginRight: 10,
  },
  input: {
    flex: 1,
    height: 40,
    backgroundColor: '#f5f5f5',
    borderRadius: 10,
    paddingHorizontal: 10,
  },
  button: {
    backgroundColor: '#FDF05D',
    borderRadius: 20,
    paddingVertical: 15,
    alignItems: 'center',
    marginTop: 20,
  },
  buttonText: {
    color: 'black',
    fontWeight: 'bold',
    fontSize: 16,
  },
  backButton: {
    position: 'absolute',
    top: 20,
    left: 20,
    zIndex: 1,
  },
  termsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    marginTop: 10,
  },
  checkbox: {
    marginRight: 10,
  },
  termsText: {
    fontSize: 12,
    color: 'black',
  },
  linkText: {
    color: 'blue',
    textDecorationLine: 'underline',
  },
    locationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 8,
  },
  sectionTitleAddress: {
    fontSize: 16,
    marginLeft: 8,
  },
  warningCard: {
    backgroundColor: '#f0f0f0', // Light grey background
    borderRadius: 25,           // Rounded corners
    padding: 15,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'darkgrey',
    marginBottom: 15,
  },
  warningText: {
    color: 'black',
    marginLeft: 10,
    fontSize: 14,
  }, 
  container: {
    flex: 1,
    padding: 20,
    justifyContent: 'center',
  },
  dropdownButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#f5f5f5',
    padding: 10,
    borderRadius: 10,
    marginVertical: 10,
  },
  dropdownButtonText: {
    color: 'black',
  },
  dropdownList: {
    backgroundColor: '#ffffff',
    borderRadius: 10,
    maxHeight: 200,
    marginTop: 5,
    borderWidth: 1,
    borderColor: '#ddd',
  },
  dropdownItem: {
    padding: 10,
  },
  dropdownItemText: {
    color: 'black',
  },
  availabilityTable: {
  borderWidth: 1,
  borderColor: '#ddd',
  borderRadius: 10,
  width: '90%',
  marginRight: '2%',
  padding: 10,
  marginVertical: 15,
  backgroundColor: '#f9f9f9',
},
row: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 10,
},
dayLabel: {
  flex: 1,
  fontSize: 14,
  color: 'black',
},
timeInput: {
  flex: 1,
  borderWidth: 1,
  borderColor: '#ddd',
  borderRadius: 5,
  paddingHorizontal: 8,
  paddingVertical: 5,
  fontSize: 12,
  backgroundColor: '#fff',
  marginHorizontal: 5,
},
modalContainer: {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
},
modalContent: {
  backgroundColor: '#fff',
  borderRadius: 10,
  padding: 20,
  width: '80%',
  alignItems: 'center',
},
modalTitle: {
  fontSize: 18,
  fontWeight: 'bold',
  marginBottom: 15,
},
timeList: {
  width: '100%',
  maxHeight: 300, // Restrict height for better scrolling experience
},
timeItem: {
  paddingVertical: 10,
  borderBottomWidth: 1,
  borderBottomColor: '#ddd',
  alignItems: 'center',
},
timeText: {
  fontSize: 16,
  color: '#000',
},
modalCloseButton: {
  marginTop: 20,
  backgroundColor: '#f5f5f5',
  padding: 10,
  borderRadius: 5,
  alignItems: 'center',
  width: '50%',
},
modalCloseButtonText: {
  color: '#000',
  textAlign: 'center',
},
charCounter: {
  fontSize: 12,
  color: 'gray',
  textAlign: 'right',
  marginTop: 5,
},
modalOverlay: {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
},
successModalContent: {
  backgroundColor: '#fff',
  borderRadius: 10,
  padding: 20,
  alignItems: 'center',
  width: '80%',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.25,
  shadowRadius: 4,
  elevation: 5, // For Android shadow
},
successModalMessage: {
  fontSize: 16,
  color: 'black',
  textAlign: 'center',
  marginBottom: 20,
},
successModalButton: {
  backgroundColor: '#FDF05D',
  borderRadius: 10,
  paddingVertical: 10,
  paddingHorizontal: 20,
},
successModalButtonText: {
  color: 'black',
  fontWeight: 'bold',
  fontSize: 14,
  textAlign: 'center',
},
successIcon: {
  marginBottom: 15,
},
editIcon: {
  marginBottom: 15,
},
toggleContainer: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginVertical: 15,
  paddingVertical: 10,
  paddingHorizontal: 15,
  backgroundColor: '#f5f5f5',
  borderRadius: 10,
},
toggleLabel: {
  fontSize: 16,
  color: 'black',
},
toggleButton: {
  width: 60,
  height: 30,
  borderRadius: 15,
  justifyContent: 'center',
  alignItems: 'center',
},
toggleOn: {
  backgroundColor: '#fdf05d',
},
toggleOff: {
  backgroundColor: 'gray',
},
toggleText: {
  color: 'white',
  fontWeight: 'bold',
},

});
